(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[962],{

/***/ 91781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/why",
      function () {
        return __webpack_require__(35699);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49099);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99304);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2261);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54013);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17857);
/* harmony import */ var _utils_useObserver__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75778);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81627);





















var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref[0], setData = ref[1];
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var forumRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var areaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var introRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        isIntro: false,
        isForum: false,
        isArea: false
    }), animate = ref1[0], setIsAnimate = ref1[1];
    var timerRefs = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({});
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadSwiper = ref2[0], setIsLoadSwiper = ref2[1];
    var visitorSwiperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var visitorRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), swiperData = ref3[0], setSwiperData = ref3[1];
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_13__/* .useTranslations */ .T_)();
    var chunkArray = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(arr, chunkSize) {
        var chunkedArray = [];
        var index = 0;
        while(index < arr.length){
            var end = Math.min(index + chunkSize, arr.length);
            chunkedArray.push(arr.slice(index, end));
            index = end;
        }
        return chunkedArray;
    }, []);
    var handleMouseEnter = function(ref) {
        var nextTransForm = "";
        // 轮播图从暂停位置移动到原本应到的位置所用的时间
        var nextTime = 0;
        if (ref.current && ref.current.swiper.autoplay) {
            var _$ref, _$ref1, _$ref2;
            var swiperDom = ref.current.swiper.el.children[0];
            // 轮播图原本应移动到的位置
            nextTransForm = swiperDom.style.transform;
            var nextTransPosition = parseInt((_$ref1 = (_$ref = swiperDom.style.transform) === null || _$ref === void 0 ? void 0 : _$ref.split("translate3d(")[1]) === null || _$ref1 === void 0 ? void 0 : _$ref1.split("px")[0], 10);
            // 鼠标悬浮时时轮播图位置
            var nowTransPosition = ref.current.swiper.getTranslate();
            // 计算轮播图从暂停位置移动到原本应到的位置所用的时间
            var swiperSlideWidth = (_$ref2 = swiperDom.children[0]) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBoundingClientRect().width;
            nextTime = 6000 * (Math.abs(Math.abs(nextTransPosition) - Math.abs(nowTransPosition)) / swiperSlideWidth);
            setSwiperData({
                nextTransForm: nextTransForm,
                nextTime: nextTime
            });
            var instance = ref.current.swiper.getTranslate();
            ref.current.swiper.setTranslate(instance);
            ref.current.swiper.autoplay.stop();
        }
    };
    var handleMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(ref) {
        if (swiperData) {
            var _$ref;
            var nextTransForm = swiperData.nextTransForm, nextTime = swiperData.nextTime;
            if (ref.current && ((_$ref = ref.current.swiper) === null || _$ref === void 0 ? void 0 : _$ref.autoplay)) {
                var _$ref1;
                var swiperDom = ref.current.swiper.el.children[0];
                swiperDom.style.transform = nextTransForm;
                swiperDom.style.transitionDuration = "1000ms";
                (_$ref1 = ref.current.swiper) === null || _$ref1 === void 0 ? void 0 : _$ref1.autoplay.start();
            }
        }
    }, [
        swiperData
    ]);
    var setObserver = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(ref, code) {
        (0,_utils_useObserver__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            if (timerRefs.current[code]) {
                clearTimeout(timerRefs.current[code]);
            }
            setIsAnimate(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, code, true));
            });
        }, function() {
        // timerRefs.current[code] = setTimeout(() => {
        //   setIsAnimate(prev => ({ ...prev, [code]: false }));
        // }, 1200)
        }, 0.2).observe(ref);
    }, [
        animate
    ]);
    var animateLoad = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setObserver(forumRef.current, "isForum");
        setObserver(areaRef.current, "isArea");
        setObserver(introRef.current, "isIntro");
    }, [
        setObserver
    ]);
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/getLogoList", {
                            params: {
                                limit: 999,
                                category_id: 1
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    setData(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.list);
                    setIsLoadSwiper(true);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getData();
        animateLoad();
        return function() {
            Object.values(timerRefs.current).forEach(clearTimeout);
        // [forumRef, areaRef, introRef].forEach(ref => {
        //   if (ref.current) observer.unobserve(ref.current);
        // });
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: navDetail === null || navDetail === void 0 ? void 0 : navDetail.sub_title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        fontWeight: "normal"
                    },
                    children: navDetail === null || navDetail === void 0 ? void 0 : navDetail.brief
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().container) || ""),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_12__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().bg1) || "")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().bg2) || "")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: introRef,
                    className: "jsx-e97cd88269d6c90" + " " + (classnames__WEBPACK_IMPORTED_MODULE_9___default()([
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().newPro),
                        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().animate), animate.isIntro)
                    ]) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().left) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.annual")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.annualText")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().right) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    onError: function(e) {
                                        return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                    },
                                    src: "/image/visitor-why-img1.png",
                                    alt: "",
                                    className: "jsx-e97cd88269d6c90"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.photoTip")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().forum) || ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: forumRef,
                        className: "jsx-e97cd88269d6c90" + " " + (classnames__WEBPACK_IMPORTED_MODULE_9___default()([
                            (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().animate), animate.isForum)
                        ]) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().left) || ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        style: {
                                            filter: "brightness(0.8)"
                                        },
                                        onError: function(e) {
                                            return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                        },
                                        loading: "lazy",
                                        src: "/image/visitor-why-forum.png",
                                        alt: "",
                                        className: "jsx-e97cd88269d6c90"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().right) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "jsx-e97cd88269d6c90",
                                        children: t("visitorWhy.conference")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-e97cd88269d6c90",
                                        children: t("visitorWhy.conferenceText")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: areaRef,
                    className: "jsx-e97cd88269d6c90" + " " + (classnames__WEBPACK_IMPORTED_MODULE_9___default()([
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().area),
                        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().animate), animate.isArea)
                    ]) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().left) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.area")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.areaText")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().right) || ""),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-e97cd88269d6c90",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    style: {
                                        filter: "brightness(0.8)"
                                    },
                                    onError: function(e) {
                                        return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                    },
                                    src: "/image/visitor-why-area.png",
                                    loading: "lazy",
                                    alt: "",
                                    className: "jsx-e97cd88269d6c90"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cates) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().info) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: t("visitorWhy.exhCate")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-e97cd88269d6c90",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().item) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate1) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate1")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 31.2,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate2) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate2")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 2.5,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().item) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate3) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate3")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 42.5,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate4) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate4")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 2.8,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().item) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate5) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate5")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 13.5,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().cate6) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: t("visitorWhy.cates.cate6")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "jsx-e97cd88269d6c90",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                    end: 7.5,
                                                                    duration: 1,
                                                                    enableScrollSpy: true,
                                                                    decimals: 1
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    style: {
                                                                        fontSize: "18px"
                                                                    },
                                                                    className: "jsx-e97cd88269d6c90",
                                                                    children: "%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onMouseEnter: function(e) {
                                return handleMouseEnter(visitorSwiperRef);
                            },
                            onMouseLeave: function(e) {
                                return handleMouseLeave(visitorSwiperRef);
                            },
                            className: "jsx-e97cd88269d6c90",
                            children: isLoadSwiper && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                                ref: visitorSwiperRef,
                                style: {
                                    paddingBottom: "30px"
                                },
                                modules: [
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt
                                ],
                                spaceBetween: 10,
                                autoplay: {
                                    delay: 0,
                                    // pauseOnMouseEnter: true,
                                    stopOnLastSlide: false,
                                    disableOnInteraction: false
                                },
                                centeredSlides: true,
                                observer: true,
                                observeParents: true,
                                speed: 2000,
                                loop: true,
                                slidesPerView: "auto",
                                children: data.length && chunkArray(data, 5).map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "jsx-e97cd88269d6c90" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_20___default().logos) || ""),
                                            children: item.map(function(child, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-e97cd88269d6c90",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: child.url ? child.url : "javascript:;",
                                                        target: child.url ? "_blank" : "_self",
                                                        className: "jsx-e97cd88269d6c90",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            onError: function(e) {
                                                                return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                                            },
                                                            src: child.image,
                                                            alt: "",
                                                            className: "jsx-e97cd88269d6c90"
                                                        })
                                                    })
                                                }, index);
                                            })
                                        })
                                    }, index);
                                })
                            })
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "e97cd88269d6c90",
                    children: ".swiper-wrapper,.swiper-slide{width:auto;-webkit-transition-timing-function:linear!important;-moz-transition-timing-function:linear!important;-o-transition-timing-function:linear!important;transition-timing-function:linear!important}"
                })
            ]
        })
    });
};


/***/ }),

/***/ 75778:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var useObserver = function(entryEvent, outEvent, threshold) {
    return new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entryEvent === null || entryEvent === void 0 ? void 0 : entryEvent();
            } else {
                outEvent === null || outEvent === void 0 ? void 0 : outEvent();
            }
        });
    }, {
        threshold: threshold
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useObserver);


/***/ }),

/***/ 49099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"why_m-1480__o0BcA","container":"why_container__aSclD","bg1":"why_bg1__qiYQ2","bg2":"why_bg2__DOfGF","animate":"why_animate__mkulB","left":"why_left__OJD7g","trunRight":"why_trunRight__l_Zvw","right":"why_right__k_WQD","trunLeft":"why_trunLeft__5tE1t","newPro":"why_newPro__RbSij","forum":"why_forum__BJ6E2","area":"why_area__5e_2d","cates":"why_cates__lpMhO","logos":"why_logos__PiF9F","info":"why_info__QDbCv","item":"why_item__GYG69","cate1":"why_cate1__k1rtN","cate2":"why_cate2__zo9i0","cate3":"why_cate3__DhJHl","cate4":"why_cate4__pQ4vl","cate5":"why_cate5__ccbtY","cate6":"why_cate6__nXAOh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,304,912,944,774,888,179], function() { return __webpack_exec__(91781); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);